var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ConfigsManager } from './modules/config/configs';
import { LogFactory } from './modules/config/logging';
import Channel from './connection/channel';
import { Call, IncomingCall } from './JiveCall';
import SessionEvents from './JiveSessionEvents';
import { Timer } from './JiveSessionUtils';
import Analytics from './modules/config/analytics';
// tslint:disable-next-line:no-console
console.log('RTCJS -> JiveRTC JSL Version ' + ConfigsManager.version);
export var Configs = function (configs) { return (ConfigsManager.configs = configs); };
export var version = ConfigsManager.version;
export var browser = ConfigsManager.browser;
var Logger = LogFactory('Session');
export var disableLogging = function () { return ConfigsManager.disableLogging(); };
export var enableLogging = function () { return ConfigsManager.enableLogging(); };
/**
 * Class representing a Jive RTC Session
 */
var Session = /** @class */ (function (_super) {
    __extends(Session, _super);
    /**
     * Create a session.
     * @param {string} username - The username value
     * @param {string} token - The token value
     * @param {string} tenantId - The pbx value
     * @param {string} extensionNumber - The extension value
     */
    function Session(username, token, tenantId, extensionNumber, store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this._channel = null;
        // String to keep track of the session channel connection state
        _this._state = _this.UNREGISTERED;
        // Map to keep track of all ongoing calls
        _this._calls = new Map();
        // Timer Object for the timeout needed for a register refresh
        _this._registerTimer = null;
        _this._audioContext = new AudioContext();
        _this._authentication = { username: username, token: token };
        _this._credentials = { tenantId: tenantId, extensionNumber: extensionNumber };
        _this._state = _this.UNREGISTERED;
        Analytics.init();
        Analytics.trackEvent('Session', 'Initial creation');
        // Connect WebSocket
        _this._connect();
        return _this;
    }
    /**
     * Private method called when the constructor is called to create the WebSocket Channel
     */
    Session.prototype._connect = function () {
        var _this = this;
        if (this._state !== this.TERMINATED) {
            // _channel Object handling WebSocket connection events and registration
            this._channel = new Channel(this._authentication);
            this._channel.on(this._channel.CONNECTED, function (session) { return _this._channelConnected(session); });
            this._channel.on(this._channel.DISCONNECTED, function (reason) { return _this._channelDisconnected(reason); });
            this._channel.on(this._channel.ERROR, function (error) { return _this._channelError(error); });
            this._channel.on(this._channel.MESSAGE, function (message) { return _this._handleChannelMessage(message); });
            this._channel.connect();
        }
    };
    /**
     * Creates an outgoing call. Note that dialing is not done automatically to give the opportunity to register to call events and dtmf audio beforehand.
     * @param callee The callee to dial. Can be an extension, a name or a phone number (not tel uri).
     * @param streamQualityUpdatesRequested Determines whether the call will emit call quality updates. Defaults to `false`.
     * @example
     * async callExtension(extension: string) {
     *   const call = session.createCall('1234', true)
     *   subscribeToEvents(call)
     *   createAudioElement(call.dtmfStream)
     *   await call.dial()
     *   return call
     * }
     */
    Session.prototype.createCall = function (callee, streamQualityUpdatesRequested) {
        if (streamQualityUpdatesRequested === void 0) { streamQualityUpdatesRequested = false; }
        if (this._state !== this.REGISTERED) {
            // Analytics.trackEvent('Session', 'Dial', this.UNREGISTERED_STATE.errorCode)
            Logger.error('Dial while unregistered error event', this.UNREGISTERED_STATE.errorCode);
            throw this.UNREGISTERED_STATE;
        }
        if (!callee) {
            // Analytics.trackEvent('Session', 'Dial', this.INVALID_CALLEE.errorCode)
            Logger.error('Dial with invalid callee error event', this.INVALID_CALLEE.errorCode);
            throw this.INVALID_CALLEE;
        }
        if (!this._channel) {
            // Analytics.trackEvent('Session', 'Dial', this.DISCONNECTED_STATE.errorCode)
            Logger.error('Dial while disconnected error event', this.DISCONNECTED_STATE.errorCode);
            throw this.UNREGISTERED_STATE;
        }
        var call = new Call(this._channel, this._audioContext, callee, this._calls, this.store, streamQualityUpdatesRequested);
        // Analytics.trackEvent('Session', 'Dial', 'CALL_CREATED')
        return call;
    };
    /**
     * Method to logout. "logout" can be called at any moment once the session is created.
     * Once 'logout' is called, the connection with the server will be terminated and
     * no more events can be sent or received.
     * @example
     * session.logout()
     */
    Session.prototype.logout = function () {
        // Analytics.trackEvent('Session', 'Logout')
        // Stop register refresh
        if (this._registerTimer) {
            this._registerTimer.stop();
        }
        // Close AudioContext
        this._audioContext.close();
        // Close all ongoing calls
        this._closeCalls(this.USER_LOGOUT);
        // Set state to terminated and close channel
        this._state = this.TERMINATED;
        if (this._channel) {
            this._channel.close();
            this._channel = null;
        }
        this.emit(this.UNREGISTERED, this.USER_LOGOUT);
    };
    Object.defineProperty(Session.prototype, "state", {
        /**
         * Get the session state value.
         * @return {string} The current session state.
         * List of returns: 'SESSION_UNREGISTERED', 'SESSION_REGISTERED', 'SESSION_REGISTERING', 'SESSION_TERMINATED'
         * @example
         * var state = session.state
         */
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "token", {
        set: function (token) {
            this._authentication.token = token;
            if (this._channel) {
                this._channel.authentication = this._authentication;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Internal JiveSession _channel Object event handlers
     */
    Session.prototype._channelConnected = function (session) {
        if (session === void 0) { session = true; }
        Logger.log('Connected event. Existing session:', session);
        this.emit(this.CONNECTION_RESTORED);
        if (!session) {
            this._closeCalls(this.SESSION_LOST);
            delete this._credentials.registrationId;
            this._setState(this.REGISTERING);
            return;
        }
        if (this._state === this.UNREGISTERED) {
            this._setState(this.REGISTERING);
        }
    };
    Session.prototype._channelError = function (error) {
        Logger.log('Error event', error);
        if (this._state !== this.UNREGISTERED) {
            this.emit(this.ERROR, error);
        }
    };
    Session.prototype._channelDisconnected = function (reason) {
        Logger.log('Disconnected event', reason);
        this.emit(this.CONNECTION_LOST, reason);
    };
    Session.prototype._handleChannelMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, sipCallId, incomingCall, call, error_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = message.event;
                        switch (_a) {
                            case 'greetings': return [3 /*break*/, 1];
                            case 'unregistered': return [3 /*break*/, 2];
                            case 'mwi': return [3 /*break*/, 3];
                            case 'incoming': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 10];
                    case 1:
                        Logger.log('Gateway Information', message.data);
                        if (this._channel && this._channel.hasOngoingSession) {
                            this._calls.forEach(function (call) { return __awaiter(_this, void 0, void 0, function () {
                                var error_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, call.renegotiate(true)];
                                        case 1:
                                            _a.sent();
                                            Logger.log('Call complete renegotiation successful');
                                            return [3 /*break*/, 3];
                                        case 2:
                                            error_2 = _a.sent();
                                            Logger.error('Call renegotiation unsuccessful', error_2);
                                            call.close(error_2);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [3 /*break*/, 11];
                    case 2:
                        // Analytics.trackEvent('Session', 'Unregistered', message.data.error.errorCode)
                        if (this.state !== this.UNREGISTERED) {
                            this._setState(this.UNREGISTERED, message.data.error);
                        }
                        return [3 /*break*/, 11];
                    case 3:
                        this.emit(this.MESSAGES, message.data);
                        return [3 /*break*/, 11];
                    case 4:
                        // Analytics.trackEvent('Call', 'Invite')
                        if (!this._channel) {
                            // TO DO: Attempt HTTP as fallback
                            Analytics.trackEvent('Call', 'Ringing', this.DISCONNECTED_STATE.errorCode);
                            Logger.error('Incoming call ringing error', this.DISCONNECTED_STATE.errorCode);
                            return [3 /*break*/, 11];
                        }
                        sipCallId = message.data.sipCallId || null;
                        incomingCall = new IncomingCall(message.data.callId, sipCallId, this._channel, this._audioContext, this._calls, message.data.name || message.data.number, message.data.number, this.store);
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 7, , 9]);
                        this._calls.set(message.data.callId, incomingCall);
                        return [4 /*yield*/, incomingCall.ringing()];
                    case 6:
                        _b.sent();
                        Analytics.trackEvent('Call', 'Ringing', 'SUCCESS');
                        call = this._calls.get(message.data.callId);
                        if (call) {
                            // Call may have ended before we get here
                            this.emit(this.INVITE, call);
                        }
                        return [3 /*break*/, 9];
                    case 7:
                        error_1 = _b.sent();
                        Analytics.trackEvent('Call', 'Ringing', error_1.errorCode);
                        Logger.error('Incoming call ringing error', error_1);
                        return [4 /*yield*/, incomingCall.reject()];
                    case 8:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        this._callMessage(message);
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    Session.prototype._callMessage = function (message) {
        if (!message.data) {
            Logger.log('Unhandled message event', message);
            return;
        }
        if (!this._calls.has(message.data.callId)) {
            Logger.log('Received event is not associated to any ongoing call');
            return;
        }
        var call = this._calls.get(message.data.callId);
        if (!call) {
            return;
        }
        switch (message.event) {
            case 'ringing':
                Analytics.trackEvent('Call', 'Ringing');
                call.emit(call.RINGING, message.data.inMedia);
                break;
            case 'answered':
                Analytics.trackEvent('Call', 'Answered');
                call.emit(call.CONNECTED);
                break;
            case 'noMedia':
                // Analytics.trackEvent('Call', 'No Media', call.NO_MEDIA_RECEIVED)
                call.emit(call.NO_MEDIA_RECEIVED, message.data.idleDurationSeconds);
                call.renegotiate(true).catch(function (error) {
                    Logger.error('Failed to renegotiate audio on NO_MEDIA_RECEIVED', error);
                });
                break;
            case 'update':
                call.emit(call.UPDATE, { name: message.data.name, number: message.data.number || '' });
                break;
            case 'ended':
                call.callEnded(message.data);
                this._calls.delete(message.data.callId);
                break;
            default:
                Logger.log('Unhandled message event', message);
                break;
        }
    };
    Session.prototype._register = function (expire) {
        var _this = this;
        if (expire === void 0) { expire = 0; }
        if (this._registerTimer) {
            this._registerTimer.stop();
        }
        var delay = (expire > 60000 ? expire - 15000 : expire);
        var register = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_3, retryAfter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this._channel) {
                            throw this.DISCONNECTED_STATE;
                        }
                        return [4 /*yield*/, this._channel.send('register', this._credentials)
                            // Analytics.trackEvent('Session', 'Registration', 'SUCCESS')
                        ];
                    case 1:
                        response = _a.sent();
                        // Analytics.trackEvent('Session', 'Registration', 'SUCCESS')
                        this._setState(this.REGISTERED);
                        this._credentials.registrationId = response.registrationId;
                        this._register(response.expires * 1000);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        // Analytics.trackEvent('Session', 'Registration', error.errorCode)
                        this._setState(this.UNREGISTERED, error_3);
                        if (this._channel && this._channel.state === this._channel.CONNECTED) {
                            if (error_3.errorCode === this.UNAVAILABLE.errorCode) {
                                if (error_3.constraintViolations && error_3.constraintViolations.length > 0) {
                                    if (error_3.constraintViolations[0].constraint) {
                                        retryAfter = Number.parseInt(error_3.constraintViolations[0].constraint, 10);
                                        this._register(retryAfter * 1000);
                                        return [2 /*return*/];
                                    }
                                }
                            }
                            if (error_3.errorCode === this._channel.UNAUTHORIZED.errorCode) {
                                if (this._registerTimer) {
                                    this._registerTimer.stop();
                                }
                                return [2 /*return*/];
                            }
                            this._register(ConfigsManager.REQUEST_TIMEOUT);
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (this._channel && this._channel.state !== this._channel.CONNECTED) {
            return;
        }
        this._registerTimer = new Timer(register, delay);
    };
    Session.prototype._setState = function (state, reason) {
        this._state = state;
        switch (state) {
            case this.UNREGISTERED:
                this.emit(state, reason);
                delete this._credentials.registrationId;
                break;
            case this.REGISTERING:
                this._register();
                this.emit(state);
                break;
            default:
                this.emit(state);
        }
    };
    Session.prototype._closeCalls = function (reason) {
        this._calls.forEach(function (call) { return call.close(reason); });
        this._calls.clear();
    };
    return Session;
}(SessionEvents));
export { Session };
//# sourceMappingURL=JiveSession.js.map